module.exports = __webpack_public_path__ + "static/media/axe-2.ec520cd6.glb";